import { Component, Inject, Input } from '@angular/core';

@Component({
  selector: 'spinner',
  styles: [require('./spinner.component.scss')], 
  template: `
    <div class="spinner" [ngClass]="classes">
      <svg viewBox="-9 -9 18 18" preserveAspectRatio="xMidYMid meet">
        <g class="spinner-g">
          <circle cx="0" cy="0" r="50%" width="100%" height="100%" fill="transparent"></circle>
          <path d="M0,0 m-8,0
              a8,8 0 1,1 16,0
              a8,8 0 1,1 -16,0
              " fill="transparent" stroke-width="2px" stroke-dasharray="50.3 50.3" stroke-linecap="round"></path>
        </g>
      </svg>
    </div>
  `,
})
export class SpinnerComponent {
  @Input() classes: string;
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/spinner/spinner.component.ts